mp.autocomplete = {
    init: function () {
        mp.autocomplete.headerSearch();

        // DEV-Helper
        //$('#mpHeaderSearch').val('man').trigger('keyup');
    },

    currentTerm: '',
    lastTerm: '',
    jqXHR: null,
    headerSearch: function () {
        $('#mpHeaderSearch').on('keyup', mp.autocomplete.execHeaderSearch);
        $(document).on('click', '#mpTopBar,#mpContent', function () {
            mp.autocomplete.hideHeaderResult();
        });
        $(document).on('keydown', function (ev) {
            // Escape
            if (ev.keyCode === 27) {
                mp.autocomplete.hideHeaderResult();
            }
        });
    },
    execHeaderSearch: function (ev) {
        // kein Exec bei Escape und Return
        if (ev.keyCode === 27 || ev.keyCode === 13) {
            return;
        }

        mp.autocomplete.currentTerm = $(this).val();
        if (mp.autocomplete.currentTerm !== '' && mp.autocomplete.currentTerm !== mp.autocomplete.lastTerm) {
            try {
                if (typeof (mp.autocomplete.jqXHR) == 'object') {
                    mp.autocomplete.jqXHR.abort();
                }
            } catch (e) {
            }

            mp.autocomplete.jqXHR = $.get('/autocomplete/header-search', {'term': mp.autocomplete.currentTerm}, function (data) {
                mp.autocomplete.currentTerm = data.term; // cleaned version
                $('#mpHeaderSearchResult').html(Mustache.render(mp.templates.headerSearch, data));
                mp.autocomplete.showHeaderResult();
            });
        } else if (mp.autocomplete.currentTerm === '') {
            mp.autocomplete.hideHeaderResult();
        } else {
            mp.autocomplete.lastTerm = mp.autocomplete.currentTerm; // INFO für später: feature Client-Cache
        }
    },
    hideHeaderResult: function () {
        if ($('body').hasClass('mpShowHeaderResults')) {
            $('body').removeClass('mpShowHeaderResults');
        }
    },
    showHeaderResult: function () {
        if (mp.autocomplete.currentTerm !== '') {
            $('body').addClass('mpShowHeaderResults');
        }
    }
};

$(document).ready(function () {
    mp.autocomplete.init();
});
